import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {link} from 'styles/fragments';

export default styled(Link)`
	${link};
`;
